import React, { useEffect, useState } from "react";
import FloatingInput from "../../../components/input/FloatingInput";
import ChipsInput from "../../../components/input/ChipsInput";
import { sendText } from "../../../pages/calculators/buyer/services/buyerNetService";

export default function TextMessageModal({ type, onClose, showToaster, sellerFormData, buyerFormData, isQuickMode, isQuickEstimate = false }) {

  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    return () => {
      setPhoneNumbers([]);
      setMessage('');
    }
  }, [])

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const ucWords = (str = "") => str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    const fullName = ucWords(`${user.first_name ?? ""} ${user.last_name ?? ""}`).trim();
    const email = user?.email || '';
    setMessage(`Closing Costs from ${fullName} at ${email}`);
  }, [])

  const handleTextData = async (e) => {
    if (!phoneNumbers.length) return;
    e.preventDefault();
    const payload = {
      phoneNumbers: phoneNumbers.map((ele) => ele.replaceAll(' - ', '')),
      type,
      isQuickMode,
      isQuickEstimate,
      data: type === 'buyer' ? buyerFormData : sellerFormData,
      // No dedicated "quick text" tracking counter exists yet (unlike
      // printquickestimate/emailquickprint), so this still tracks as a
      // regular textmessage — isQuickEstimate above is what selects the
      // template, independent of this tracking label.
      optionType: "textmessage",
      message,
      mrsid: type === 'buyer' ? buyerFormData?.addressMeta?.mrsid : sellerFormData?.addressMeta?.mrsid,
    }
    const res = await sendText(payload);
    if (res?.status === 'success') {
      showToaster({ message: res?.message, visible: true })
      onClose();
    }
  }


  return (
    <div className="modelspace pplication-fe model-select space-fields">
      <div className="frm-field-1 model-select-lbl">
        <div className="form-group">
          <label>To: (press tab to add more mobile numbers), format : 000 - 000 - 0000</label>
          <ChipsInput value={phoneNumbers} onChange={data => setPhoneNumbers(data)} maxLength={20}
            placeholder="Phone Number" inputType="text" />
        </div>
      </div>

      <div className="frm-field-1 model-select-lbl">
        <div className="form-group">
          <FloatingInput type="text" value={message} onChange={(e) => setMessage(e.target.value)} />
          <label>Message</label>
        </div>
      </div>

      <div className="frm-btn popup-2-btn">
        <button className="submit-btn btn-bg inpt-btn btn-discard" onClick={onClose}>Cancel</button>
        <button className="submit-btn btn-bg inpt-btn" onClick={handleTextData}
          disabled={!phoneNumbers.length}>Send</button>
      </div>
    </div>
  );
}
